import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useFeatures } from '../context/FeatureContext';

export default function HistoricalFeatureNotice({ feature }) {
  const { companyId } = useParams();
  const { featureName } = useFeatures();
  return <div className="alert alert-info mx-3 mt-3" role="status">
    Du visar tidigare uppgifter i {featureName(feature)}. Funktionen ingår inte längre i ditt paket och nya ändringar är spärrade.{' '}
    <Link to={`/${companyId}/settings/subscription`}>Se planer och tillägg</Link>
  </div>;
}
